
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import { getActiveFilters } from '../../methods';

import { filterActions } from '../../../../../../pages/Search/actions';

import { display } from '../../../../../../commonStyles.js';
import styles from './styles.js';

const mapStateToProps = state => ({
    activeFilterGroupCollectionIndex: state.activeFilterGroupCollectionIndex,
    filterGroups: state.filterGroups,
    lang: state.lang
});

const mapDispatchToProps = dispatch => ({
    setActiveFilterGroupCollection: filterGroupCollectionIndex =>
        dispatch(filterActions.setActiveFilterGroupCollection(filterGroupCollectionIndex))
});

class FilterGroupCollection extends Component {
    static propTypes = {
        activeFilterGroupCollectionIndex: PropTypes.number.isRequired,
        filterGroupCollection: PropTypes.object.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        handleActiveFilterGroupCollection: PropTypes.func.isRequired,
        setActiveFilterGroupCollection: PropTypes.func.isRequired
    }

    state = {
        hover: false
    }

    isHovering = () => {
        this.setState({ hover: true });
    }

    isNotHovering = () => {
        this.setState({ hover: false });
    }

    handleToggleFilter = () => {
        const {
            filterGroupCollectionIndex,
            handleActiveFilterGroupCollection
        } = this.props;
        handleActiveFilterGroupCollection(filterGroupCollectionIndex);
    }

    render() {
        const { handleToggleFilter, isHovering, isNotHovering } = this;
        const { hover } = this.state;
        const {
            activeFilterGroupCollectionIndex,
            filterGroupCollection,
            filterGroupCollectionIndex
        } = this.props;
        const activeFilterCount = getActiveFilters(filterGroupCollection);
        return (
            <button
                role="menuitem"
                aria-haspopup="true"
                className={css(
                    styles.menuItem,
                    Number(activeFilterGroupCollectionIndex) === Number(filterGroupCollectionIndex) &&
                    styles.menuItemActive,
                    hover && styles.menuItemActive
                )}
                onMouseEnter={isHovering}
                onMouseLeave={isNotHovering}
                onClick={handleToggleFilter}
            >
                <div className={css(styles.label)}>
                    <span
                        dangerouslySetInnerHTML={{ __html: filterGroupCollection.buttonText }}
                    />
                    {
                        activeFilterCount > 0 ?
                            <div
                                className={css(display.inlineBlock)}
                                style={{ marginLeft: '4px' }}
                            >
                                <div className={css(styles.badgeContainer)}>
                                    {activeFilterCount}
                                </div>
                            </div> : null
                    }
                </div>
                <span className={css(styles.chevron)}>
                    <div
                        className={css(
                            Number(activeFilterGroupCollectionIndex) === Number(filterGroupCollectionIndex) ?
                                styles.iconWrapperOpen : styles.iconWrapper
                        )}
                    >
                        <svg
                            className={css(styles.chevronSvg)}
                            viewBox="0 0 18 18"
                            role="presentation"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <path
                                fillRule="evenodd"
                                d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                            />
                        </svg>
                    </div>
                </span>
            </button>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterGroupCollection);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Button/Button.jsx